import { MapPin, Calendar, ArrowRight } from "lucide-react";

export const formatDateWithTime = (dateString: string) => {
  const date = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = {
    month: "long",
    day: "numeric",
    year: "numeric",
  };

  // Check if the input date string includes time information
  if (dateString.includes("T")) {
    options.hour = "numeric";
    options.minute = "numeric";
    options.second = "numeric";
    options.hour12 = true; // If you want to use 12-hour format
  }

  return date.toLocaleDateString("en-US", options);
};

function RecentJobCard({
  id,
  title,
  body,
  category,
  thumbnail,
  date,
  location,
  ...props
}: any) {
  return (
    <div key={id} className="cht-h-full">
      <div className="cht-group cht-relative cht-overflow-hidden cht-rounded-[22px] cht-border cht-border-slate-200/80 cht-bg-white cht-shadow-soft hover:cht-shadow-float hover:cht-border-[#3e57da]/40 cht-transition-all cht-duration-300 cht-flex cht-flex-col cht-h-full !cht-font-body">
        <div className="cht-relative cht-aspect-[16/9] cht-w-full cht-overflow-hidden cht-bg-slate-100">
          <img
            src={thumbnail}
            alt={`Screenshot of ${title}`}
            className="cht-w-full cht-h-full cht-object-cover group-hover:cht-scale-105 cht-transition-transform cht-duration-500"
            loading="lazy"
          />
          {location && (
            <div className="cht-absolute cht-top-3 cht-left-3 cht-backdrop-blur-md cht-bg-[#1e293b]/75 cht-text-white cht-text-xs cht-font-medium cht-px-3 cht-py-1 cht-rounded-full cht-flex cht-items-center cht-gap-1.5 cht-border cht-border-white/10">
              <MapPin className="cht-w-3 cht-h-3 " />
              <span>{location}</span>
            </div>
          )}
        </div>

        <div className="cht-p-5 sm:cht-p-6 cht-flex cht-flex-col cht-flex-1 cht-justify-between">
          <div>
            {category && category.length > 0 && (
              <div className="cht-flex cht-flex-wrap cht-gap-1.5 cht-mb-2.5">
                {category.map((cat: any, idx: number) => (
                  <span
                    key={cat.id || idx}
                    className="cht-text-[11px] cht-font-semibold cht-uppercase cht-tracking-wider cht-text-[#3e57da] cht-bg-[#3e57da]/10 cht-px-2.5 cht-py-0.5 cht-rounded-md"
                  >
                    {cat.name}
                  </span>
                ))}
              </div>
            )}

            <h5 className="cht-text-lg sm:cht-text-xl cht-font-bold !cht-font-heading cht-text-[#1e293b] group-hover:cht-text-[#3e57da] cht-transition-colors cht-line-clamp-2 cht-mb-2">
              {title}
            </h5>

            {date && (
              <p className="cht-text-xs cht-text-slate-600 cht-flex cht-items-center cht-gap-1.5 cht-mb-0">
                <Calendar className="cht-w-3.5 cht-h-3.5" />
                {formatDateWithTime(date)}
              </p>
            )}
          </div>

          <div className="cht-pt-4 cht-mt-4 cht-border-t cht-border-slate-100 cht-flex cht-items-center cht-justify-between cht-text-xs cht-font-semibold cht-text-[#3e57da]">
            <span>View Deliverable Case</span>
            <ArrowRight className="cht-w-4 cht-h-4 group-hover:cht-translate-x-1 cht-transition-transform" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default RecentJobCard;
